import { render, staticRenderFns } from "./top-aside.vue?vue&type=template&id=0b9be402&scoped=true&"
import script from "./top-aside.vue?vue&type=script&lang=js&"
export * from "./top-aside.vue?vue&type=script&lang=js&"
import style0 from "./top-aside.vue?vue&type=style&index=0&id=0b9be402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9be402",
  null
  
)

export default component.exports